/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {DiplomatObject} from './DiplomatObject';

export const JobHistorySettings = DiplomatObject.shape({
   jobHistoryRequired: yup.boolean(),
   retainByAge: yup.boolean(),
   retainByRecords: yup.boolean(),
   maxAge: yup.number().integer(),
   maxNumberRecords: yup.number().integer(),
   detailedJobHistory: yup.boolean(),
   clientUpdateRate: yup.number().integer(),
});

export type IJobHistorySettings = yup.InferType<typeof JobHistorySettings>;
